<script>
export default {
    props: ['field', 'modelValue'],
    data() {
        return {
            state: this.modelValue,
        }
    },
    computed: {
        fieldHasOptions() {
            return Object.keys(this.field.coding).length > 0;
        },
        fieldInputType() {
            switch (this.field.type) {
                case 'integer':
                    return 'number';
                case 'varchar':
                default:
                    return 'text';
            }
        }
    },
    watch: {
        state() {
            this.$emit('update:modelValue', this.state);
        }
    }
}
</script>

<template>
    <label class="form-label"><span class="fw-bold">Field:&nbsp;</span> {{ field.name }}</label>
    <label class="form-label" v-if="field.description"><span class="fw-bold">Description:&nbsp;</span>{{ field.description }}</label>

    <template v-if="fieldHasOptions">
        <label class="form-label fw-bold">Options:</label>
        <div class="mb-3 columns-2">
            <div v-for="label, value in field.coding" class="form-check">
                <label class="form-check-label" :for="value">
                    {{ label }}
                </label>
                <input type="checkbox" class="form-check-input" :id="value" :value="value" :name="value" v-model="state">


            </div>
        </div>
    </template>
    <template v-else>
        <label class="form-label">
            <span class="fw-bold">{{ field.name }}</span>
            <input class="form-control" :id="field.label" :type="fieldInputType" v-model="state[0]" />
        </label>

    </template>

    <label class="form-label" v-if="field.notes"><span class="fw-bold">Notes:&nbsp;</span>{{ field.notes }}</label>
</template>

<style>
.columns-2 {
    columns: 2;
}
</style>